import React from 'react';
import styled from 'styled-components';
import { ExternalLink } from 'components/styled/ui';

// const formatUrl = url => url.replace(/(^\w+:|^)\/\//, '');

const formatUrl = url => {
  if (url) {
    var urlParts = url
      .replace('http://', '')
      .replace('https://', '')
      .split(/[/?#]/);
    var domain = urlParts[0];
    return domain;
  }
};

const Sources = ({ sources }) => {
  return (
    <Content className="sources">
      {sources.map((link, index) => (
        <ExternalLink href={link} target="_blank" key={index}>
          {formatUrl(link)}
        </ExternalLink>
      ))}
    </Content>
  );
};

export default Sources;

const Content = styled.div`
  > span {
    color: rgba(74, 74, 74, 0.5);
    margin-right: 6px;
    font-size: 14px;
  }
  a {
    font-size: 14px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/layouts/sources/sources.js